import { pdf } from "@react-pdf/renderer";
import { PdfDocumentEnvelope } from "components/Loan/LoanMain";
import React, { useState } from "react";
import { saveAs } from "file-saver";
import { Button } from "./wrapper";
import PDFMerger from "pdf-merger-js/browser";
import { getCurrentLocalDateTime } from "utils/getLocalDateTime";

const Minizip = require("minizip-asm.js");

function Envelope({ loan = [], customDisabled = false }) {
  const [loading, setLoading] = useState(false);

  const onClickEvelope = async () => {
    try {
      setLoading(true);
      const mz = new Minizip();
      const merger = new PDFMerger();
      for (const itemLoan of loan) {
        let newLoan = [{ original: itemLoan }];

        let BufferEnvelope = await pdf(
          <PdfDocumentEnvelope loan={newLoan} isCurrentAddress={false} />
        ).toBlob();

        await merger.add(BufferEnvelope);
        // const mergerBlob = await merger.saveAsBuffer();
        // saveAs(mergerBlob, filenameZip);
        // mz.append(filename, mergerBlob);
      }

      // let filenameZip = `EXPORT_${loan?.length}.zip`;
      // const fileMerger = new File([mz.zip()], filenameZip, {
      //   type: "application/x-zip-compressed",
      // });

      // saveAs(fileMerger, filenameZip);
      let filename = `EXPORT_LETTER_${
        getCurrentLocalDateTime(new Date()).fullDate
      }`;
      await merger.save(filename);
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex">
      <Button
        onClick={onClickEvelope}
        disabled={loan.length === 0 || loading || customDisabled}
        loading={loading}
        color="blue"
      >
        Envelope
      </Button>
    </div>
  );
}

export default Envelope;
